import { render, staticRenderFns } from "./xlwy.vue?vue&type=template&id=02b5384e"
import script from "./xlwy.vue?vue&type=script&lang=js"
export * from "./xlwy.vue?vue&type=script&lang=js"
import style0 from "./xlwy.vue?vue&type=style&index=0&id=02b5384e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports